// css "plugins"
import "./global.css"

// window "plugins"
import "./plugins/highcharts"
import "./plugins/fontawesome"

// Vellum app entry
import "vellum:main"